export async function fetchHomepageLapTimes(seasonName, signal) {
  if (!seasonName) return [];
  const base = 'https://iracing6-backend.herokuapp.com/api/series-avg-lap-times';
  for (const route of ['average-lap-time', 'average-race-lap-time']) {
    const response = await fetch(`${base}/${route}/${encodeURIComponent(seasonName)}`, { signal });
    if (!response.ok) continue;
    const data = await response.json();
    if (Array.isArray(data) && data.length > 0) return data;
  }
  return [];
}
